/**
 * @file Datasource
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @private
 */
/**
 * Datasource base class
 * @interface
 */
class Datasource {
}
export default Datasource;
